const state = {
    sectorList : []
}
const mutations = {
    setSectorList(base, data){
        base.sectorList = data;
    },
    
    addSectorList(base, data){
        base.sectorList.push(data);
    }
}
const getters = {
    getSectorsTree(base){
        
        const masterSector = base.sectorList.sort((a,b) => a.type.level - b.type.level).at(0);
        if(!masterSector){
            return []
        }
        masterSector.sectors = getChild(base.sectorList, masterSector.id);
        return masterSector;
    },
}

function getChild(ds, id){
    const children = ds.filter(a => a.fatherId === id);
    children.forEach(a=>{
        a.sectors = getChild(ds, a.id)
    });
    return children;
}

export default {
    namespaced: true,
    state,
    mutations,
    getters
}